export default __webpack_public_path__ + "static/piscina-prainha-7ee156f70de07eda5de7134d6b39fba9.jpg";